import React, { useContext, useLayoutEffect } from "react";
import { Navigate, Outlet, useLocation, useParams } from "react-router-dom";
import { useLogin } from "../reducers";
import { updateHash } from "../utils/urlHash";
import { canBrowseTeamSessions } from "../components/dashboard/personalSessionsModel";
import PersonalSessions from "../components/dashboard/PersonalSessionsBrowser";
import { ActivityPageContext } from "../components/dashboard/ActivityPageContext";

// Hash param key owned by the sessions routes (registered in urlHash's HashParamKey).
export const RECORDING_USERS_HASH_KEY = "ru";

export default function SessionsLayout() {
  const { user, permissions } = useLogin();
  const location = useLocation();
  const { recordingId } = useParams();
  const setPersonal = useContext(ActivityPageContext);
  const teamAccess = canBrowseTeamSessions(permissions.recordings.visualization, user.id);
  const search = new URLSearchParams(location.search);
  const mine = search.get("sessions") === "mine";
  const personal = !teamAccess || (!!recordingId && mine);
  useLayoutEffect(() => {
    if (!teamAccess) setPersonal(true);
  }, [teamAccess, setPersonal]);
  // Keep the detail page mounted so session hops retain the person's navigation directory.
  if (personal) return recordingId ? <Outlet /> : <PersonalSessions />;
  // Turn personal landing links into the people selection the team landing reads on mount,
  // before it mounts: a landing that already synced its previous selection would restore it.
  if (mine && !recordingId) {
    search.delete("sessions");
    return (
      <Navigate
        replace
        to={{
          pathname: location.pathname,
          search: search.toString(),
          hash: updateHash(location.hash, { [RECORDING_USERS_HASH_KEY]: user.id }),
        }}
      />
    );
  }
  return <Outlet />;
}
